import { AccountClient, CenterClient, ErrorClient, LogsClient, ModelDeviceServiceClient, CenterSettingsClient } from './generated';
import { axiosWithAuth } from './apiClient';

export const accountClient = new AccountClient('', axiosWithAuth);
export const centerClient = new CenterClient('', axiosWithAuth);
export const centerSettingsClient = new CenterSettingsClient('', axiosWithAuth);
export const errorClient = new ErrorClient('', axiosWithAuth);
export const logsClient = new LogsClient('', axiosWithAuth);
export const modelDeviceServiceClient = new ModelDeviceServiceClient('', axiosWithAuth);